import {Center, Flex, Icon, Image, Text} from '@chakra-ui/react'
import Logo from '@assets/svgs/roadmap/logo.svg'
import MicIcon from '@assets/svgs/roadmap/mic.svg'
import avatarFull from '@assets/images/paraphrase/avatar_full.png'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {CommonColors} from '@utils/CommonStyles'
import {ReactComponent as ArrowRightIcon} from '@assets/svgs/learn/arrow_right_6.svg'
import {useSelector} from 'react-redux'

const Intro = ({
  setStep,
  setIsShowExample,
}: {
  setStep: (value: number) => void
  setIsShowExample: (value: boolean) => void
}) => {
  const {isFirstTime} = useSelector((state: any) => state.paraphrase)

  return (
    <Flex
      h={'100%'}
      flexDirection={'column'}
      sx={{
        '@keyframes fadeIn': {
          '0%': {opacity: 0},
          '100%': {opacity: 1},
        },
      }}>
      <Center animation={'fadeIn 0.5s ease-in'}>
        <Flex w={'fit-content'} alignItems="center" cursor="pointer">
          <Image src={MicIcon} alt="IELTS Coach Logo" mr={2} />
          <Image src={Logo} alt="IELTS Coach Logo" />
        </Flex>
      </Center>
      <Flex
        flex={1}
        gap={{base: '20px', md: '40px', lg: '80px'}}
        alignItems={'center'}
        justifyContent={'center'}
        m={'auto'}
        flexDirection={{base: 'column', md: 'row'}}
        px={{base: '16px', md: '32px'}}>
        <Image
          src={avatarFull}
          alt="avatarFull"
          animation={'fadeIn 0.5s ease-in 0.3s'}
          opacity={0}
          w={{base: '70px', md: 'auto'}}
          sx={{
            animationFillMode: 'forwards',
          }}
        />
        <Flex flexDirection={'column'} alignItems={'center'} gap={'32px'}>
          <Text
            fontSize={{base: '32px', md: '40px', lg: '48px'}}
            fontWeight={'600'}
            maxW={'400px'}
            textAlign={'center'}
            animation={'fadeIn 0.5s ease-in 0.6s'}
            opacity={0}
            sx={{
              animationFillMode: 'forwards',
            }}>
            Paraphrase bằng từ đồng nghĩa
          </Text>
          <Text
            fontSize={{base: '16px', md: '18px', lg: '20px'}}
            maxW={'500px'}
            textAlign={'center'}
            animation={'fadeIn 0.5s ease-in 0.9s'}
            opacity={0}
            sx={{
              animationFillMode: 'forwards',
            }}>
            Trong bài thi IELTS, một trong những cách nhanh nhất để paraphrase
            là sử dụng{' '}
            <Text as={'span'} color={CommonColors.primary}>
              từ đồng nghĩa
            </Text>
            . Bạn hãy xem cách chúng mình sử dụng từ đồng nghĩa để{' '}
            <Text as={'span'} color={CommonColors.primary}>
              paraphrase
            </Text>{' '}
            câu sau nhé.
          </Text>
          <Text
            fontSize={'16px'}
            textAlign={'center'}
            color={CommonColors.primary}
            animation={'fadeIn 0.5s ease-in 1.2s'}
            opacity={0}
            sx={{
              animationFillMode: 'forwards',
            }}>
            Ex: The teacher explained the difficult lesson
          </Text>
          <Flex
            animation={'fadeIn 0.5s ease-in 1.5s'}
            opacity={0}
            sx={{
              animationFillMode: 'forwards',
            }}>
            <GlobalButton
              rightIcon={<Icon as={ArrowRightIcon} />}
              onClick={() => {
                if (isFirstTime) {
                  setStep(2)
                } else {
                  setIsShowExample(false)
                }
              }}>
              Bắt đầu
            </GlobalButton>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default Intro
